import { FiInbox } from 'react-icons/fi';

export default function EmptyState({ title = 'Nothing here yet', message, icon, action }) {
  const Icon = icon || FiInbox;
  return (
    <div className="hrms-empty">
      <Icon size={28} />
      <div style={{ fontWeight: 600, marginTop: 8 }}>{title}</div>
      {message && <div className="hrms-muted" style={{ marginTop: 4 }}>{message}</div>}
      {action && <div style={{ marginTop: 12 }}>{action}</div>}
    </div>
  );
}
